module.exports = __webpack_public_path__ + "static/media/candle-holder.3386cbd9.svg";